import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Scale } from "lucide-react";

export default function ClassActionFeed({ items, onClaim }) {
  return (
    <Card className="tactile-card rounded-md p-5" data-testid="class-action-feed">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#00E676]">QUIET CLAIM LAYER</div>
          <h3 className="font-display text-lg font-bold tracking-tight">Class actions matched</h3>
        </div>
        <Scale className="h-4 w-4 text-[#606872]" />
      </div>
      <div className="space-y-3">
        {items.map((c) => (
          <div key={c.id} className="border-t border-dashed border-[#282C30] pt-3 first:border-t-0 first:pt-0" data-testid={`class-action-${c.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-display font-bold text-sm truncate">{c.title}</div>
                <div className="text-xs text-[#A0A7B0] mt-0.5 line-clamp-2">{c.match_reason}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-display text-lg font-bold text-[#00E676] tabular-nums">~${c.estimated_payout.toFixed(0)}</div>
                <div className="font-mono text-[9px] uppercase tracking-widest text-[#606872]">est. payout</div>
              </div>
            </div>
            {!c.claimed ? (
              <Button size="sm" onClick={() => onClaim(c.id)} className="btn-emerald w-full mt-3 h-8 text-xs" data-testid={`class-action-claim-${c.id}`}>
                File claim · 0% cut
              </Button>
            ) : (
              <a href={c.claim_url} target="_blank" rel="noreferrer" className="mt-3 block text-center font-mono text-[10px] uppercase tracking-widest text-[#00E676] bg-[#00E676]/10 border border-[#00E676]/30 rounded-sm py-1.5 hover:bg-[#00E676]/20" data-testid={`class-action-claimed-${c.id}`}>
                Claim filed · reopen form ↗
              </a>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-[#A0A7B0]">No matches yet. We check daily.</div>}
      </div>
    </Card>
  );
}
